module.exports = __webpack_public_path__ + "img/sliderBanner5.389c5c1e.png";